/**
 * retorna valor do campo select|checkbox que ativa campo relacionado true|false, onde campo o preenchido retorna true
 */
export function shouldActivate(element) {
    if (element.tagName == 'SELECT') {
        return (element.value.length > 0);
    } else {
        return element.checked;
    }
}

export const DATA_ATTRIBUTES = {
    autocomplete: 'UI-autocomplete-object',
    multiAutocomplete: 'UI-multi-autocomplete-object'
}
